import { useAddonConfig } from '../contexts/AddonConfigContext';
import { TERMINOLOGY } from '../constants/terminology';

export function useTerminology(language: string = 'ko', isLiveMode: boolean = false) {
  const { addonConfigMap } = useAddonConfig();

  const getFeatureName = (featureKey: keyof typeof TERMINOLOGY) => {
    const term = TERMINOLOGY[featureKey] as any;
    // 실거래 모드가 아니거나 모의투자 모드인 경우 전용 워딩이 있으면 우선 적용
    if (!isLiveMode && term.simulation_ko) {
      return language === 'ko' ? term.simulation_ko : (term.simulation_en || term.en);
    }
    // 1순위: DB에 설정된 부가상품 명칭 (한국어 기준)
    if (language === 'ko' && addonConfigMap[term.id]?.name) {
      return addonConfigMap[term.id].name;
    }
    // 2순위: 중앙 사전에 정의된 다국어 명칭
    return term[language === 'ko' ? 'ko' : 'en'];
  };

  return { getFeatureName };
}
